import "../../assets/css/section.css";
import Shimmer from "../Shimmer/Shimmer";
import useMediaQuery from "../Hooks/useMediaQuery";

export function Section(props) {
  const { classList, isLoading=false, shimmerProps={}, children, sectionRef=null } = props;
  const sectionClassList = `section-container ${classList}`;
  const { deviceScreen } = useMediaQuery();
  const isMobile = ["x-small", "small"].includes(deviceScreen);
  const showShimmer = (!!isMobile && !!isLoading);

  if (showShimmer) {
    return (
      <div className={sectionClassList}>
        <Shimmer 
          className={`section-shimmer ${shimmerProps.classList || ""}`}
          isLoading={true}
          height={shimmerProps.height || "165px"}
          {...shimmerProps}
        />
      </div>
    );
  }

  return (
    <div className={sectionClassList} ref={sectionRef}>
      {children}
    </div>
  );
}

export default Section;